import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { editAuth, getData } from "../../../actions/fair/index";
import AuthForm from "../../../components/forms/fair/AuthForm";
import { IntlText } from "../../../components/util/Text";
import { Notification } from "../../../utils/notification";

declare var UIkit;

class AuthScreen extends PureComponent {
  state = {
    fair: null,
    editing: {},
  };

  componentWillMount = () => {
    this.props.actions
      .getData()
      .then(({ value, action }) => {
        if (value.status < 300) {
          this.setState({
            fair: value.data,
            editing: value.data,
          });
        }
      })
      .catch((error) => console.log(error));
  };

  onSubmitAuth = (values) => {
    return this.props.actions.editAuth(values);
  };

  onSuccessAuth = (data) => {
    Notification.successIntl("util.success.update");
  };

  render = () => {
    return (
      <div>
        <h1>
          <IntlText id="fair.settings.title" />
        </h1>

        <div className="uk-margin-medium">
          <h2 className="uk-heading-mark">
            <IntlText id="fair.settings.authorize" />
          </h2>
          <div className="uk-margin">
            <AuthForm
              initialValues={{ email: this.state.editing.email }}
              onSuccess={this.onSuccessAuth}
              onSubmit={this.onSubmitAuth}
            />
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
    fair: state.auth.data ? state.auth.data : {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getData: () => dispatch(getData()),
      editAuth: (...param) => dispatch(editAuth(...param)),
    },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AuthScreen),
);
